/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * WorkspacesApi - axios parameter creator
 * @export
 */
export const WorkspacesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new workspace.
         * @param {CreateWorkspaceDto} createWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerCreate: (createWorkspaceDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createWorkspaceDto' is not null or undefined
            assertParamExists('workspaceControllerCreate', 'createWorkspaceDto', createWorkspaceDto);
            const localVarPath = `/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createWorkspaceDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all workspaces.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerFindAll: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all workspaces with pagination.
         * @param {Array<AbnStatusEnum>} [abnStatus]
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<GstStatusEnum>} [gstStatus]
         * @param {Array<MembershipStatusEnum>} [membershipStatus]
         * @param {string} [name]
         * @param {Array<string>} [workspaceIds] Filter workspaces whose id is in the provided list.
         * @param {Array<WorkspaceStatusEnum>} [workspaceStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindAllV2: (abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/workspace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (abnStatus) {
                localVarQueryParameter['abnStatus'] = abnStatus;
            }
            if (allowPayments !== undefined) {
                localVarQueryParameter['allowPayments'] = allowPayments;
            }
            if (gstStatus) {
                localVarQueryParameter['gstStatus'] = gstStatus;
            }
            if (membershipStatus) {
                localVarQueryParameter['membershipStatus'] = membershipStatus;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (workspaceIds) {
                localVarQueryParameter['workspaceIds'] = workspaceIds;
            }
            if (workspaceStatus) {
                localVarQueryParameter['workspaceStatus'] = workspaceStatus;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get workspace by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerFindOne', 'id', id);
            const localVarPath = `/workspace/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check whether MSR2 serves the add-title embed for this workspace.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerGetMsr2AddTitleAvailability: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerGetMsr2AddTitleAvailability', 'id', id);
            const localVarPath = `/workspace/{id}/msr2-embed/add-title-available`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a workspace by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerRemove', 'id', id);
            const localVarPath = `/workspace/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing workspace.
         * @param {string} id
         * @param {UpdateWorkspaceDto} updateWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdate: (id, updateWorkspaceDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdate', 'id', id);
            // verify required parameter 'updateWorkspaceDto' is not null or undefined
            assertParamExists('workspaceControllerUpdate', 'updateWorkspaceDto', updateWorkspaceDto);
            const localVarPath = `/workspace/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkspaceDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set allowPayments on a workspace (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateAllowPayments: (id, updateAllowPaymentsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdateAllowPayments', 'id', id);
            // verify required parameter 'updateAllowPaymentsDto' is not null or undefined
            assertParamExists('workspaceControllerUpdateAllowPayments', 'updateAllowPaymentsDto', updateAllowPaymentsDto);
            const localVarPath = `/workspace/{id}/allow-payments`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllowPaymentsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update workspace business details.
         * @param {string} id
         * @param {UpdateWorkspaceBusinessDetailsDto} updateWorkspaceBusinessDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateBusinessDetails: (id, updateWorkspaceBusinessDetailsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdateBusinessDetails', 'id', id);
            // verify required parameter 'updateWorkspaceBusinessDetailsDto' is not null or undefined
            assertParamExists('workspaceControllerUpdateBusinessDetails', 'updateWorkspaceBusinessDetailsDto', updateWorkspaceBusinessDetailsDto);
            const localVarPath = `/workspace/{id}/business-details`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkspaceBusinessDetailsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update workspace contact details.
         * @param {string} id
         * @param {UpdateWorkspaceContactDetailsDto} updateWorkspaceContactDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateContactDetails: (id, updateWorkspaceContactDetailsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdateContactDetails', 'id', id);
            // verify required parameter 'updateWorkspaceContactDetailsDto' is not null or undefined
            assertParamExists('workspaceControllerUpdateContactDetails', 'updateWorkspaceContactDetailsDto', updateWorkspaceContactDetailsDto);
            const localVarPath = `/workspace/{id}/contact-details`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkspaceContactDetailsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update workspace details.
         * @param {string} id
         * @param {UpdateWorkspaceDetailsDto} updateWorkspaceDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateDetails: (id, updateWorkspaceDetailsDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdateDetails', 'id', id);
            // verify required parameter 'updateWorkspaceDetailsDto' is not null or undefined
            assertParamExists('workspaceControllerUpdateDetails', 'updateWorkspaceDetailsDto', updateWorkspaceDetailsDto);
            const localVarPath = `/workspace/{id}/details`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkspaceDetailsDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update workspace profile picture.
         * @param {string} id
         * @param {UpdateWorkspaceProfilePictureDto} updateWorkspaceProfilePictureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateProfilePicture: (id, updateWorkspaceProfilePictureDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workspaceControllerUpdateProfilePicture', 'id', id);
            // verify required parameter 'updateWorkspaceProfilePictureDto' is not null or undefined
            assertParamExists('workspaceControllerUpdateProfilePicture', 'updateWorkspaceProfilePictureDto', updateWorkspaceProfilePictureDto);
            const localVarPath = `/workspace/{id}/profile-picture`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkspaceProfilePictureDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WorkspacesApi - functional programming interface
 * @export
 */
export const WorkspacesApiFp = function (configuration) {
    const localVarAxiosParamCreator = WorkspacesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new workspace.
         * @param {CreateWorkspaceDto} createWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerCreate(createWorkspaceDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerCreate(createWorkspaceDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all workspaces.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerFindAll(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerFindAll(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all workspaces with pagination.
         * @param {Array<AbnStatusEnum>} [abnStatus]
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<GstStatusEnum>} [gstStatus]
         * @param {Array<MembershipStatusEnum>} [membershipStatus]
         * @param {string} [name]
         * @param {Array<string>} [workspaceIds] Filter workspaces whose id is in the provided list.
         * @param {Array<WorkspaceStatusEnum>} [workspaceStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get workspace by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Check whether MSR2 serves the add-title embed for this workspace.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerGetMsr2AddTitleAvailability(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerGetMsr2AddTitleAvailability(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a workspace by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing workspace.
         * @param {string} id
         * @param {UpdateWorkspaceDto} updateWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdate(id, updateWorkspaceDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdate(id, updateWorkspaceDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set allowPayments on a workspace (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update workspace business details.
         * @param {string} id
         * @param {UpdateWorkspaceBusinessDetailsDto} updateWorkspaceBusinessDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update workspace contact details.
         * @param {string} id
         * @param {UpdateWorkspaceContactDetailsDto} updateWorkspaceContactDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update workspace details.
         * @param {string} id
         * @param {UpdateWorkspaceDetailsDto} updateWorkspaceDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update workspace profile picture.
         * @param {string} id
         * @param {UpdateWorkspaceProfilePictureDto} updateWorkspaceProfilePictureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WorkspacesApi - factory interface
 * @export
 */
export const WorkspacesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WorkspacesApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new workspace.
         * @param {CreateWorkspaceDto} createWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerCreate(createWorkspaceDto, options) {
            return localVarFp
                .workspaceControllerCreate(createWorkspaceDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all workspaces.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerFindAll(options) {
            return localVarFp
                .workspaceControllerFindAll(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all workspaces with pagination.
         * @param {Array<AbnStatusEnum>} [abnStatus]
         * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
         * @param {Array<GstStatusEnum>} [gstStatus]
         * @param {Array<MembershipStatusEnum>} [membershipStatus]
         * @param {string} [name]
         * @param {Array<string>} [workspaceIds] Filter workspaces whose id is in the provided list.
         * @param {Array<WorkspaceStatusEnum>} [workspaceStatus]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options) {
            return localVarFp
                .workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get workspace by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerFindOne(id, options) {
            return localVarFp
                .workspaceControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check whether MSR2 serves the add-title embed for this workspace.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerGetMsr2AddTitleAvailability(id, options) {
            return localVarFp
                .workspaceControllerGetMsr2AddTitleAvailability(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a workspace by id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerRemove(id, options) {
            return localVarFp
                .workspaceControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing workspace.
         * @param {string} id
         * @param {UpdateWorkspaceDto} updateWorkspaceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdate(id, updateWorkspaceDto, options) {
            return localVarFp
                .workspaceControllerUpdate(id, updateWorkspaceDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set allowPayments on a workspace (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
         * @param {string} id
         * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
            return localVarFp
                .workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update workspace business details.
         * @param {string} id
         * @param {UpdateWorkspaceBusinessDetailsDto} updateWorkspaceBusinessDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options) {
            return localVarFp
                .workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update workspace contact details.
         * @param {string} id
         * @param {UpdateWorkspaceContactDetailsDto} updateWorkspaceContactDetailsDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options) {
            return localVarFp
                .workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update workspace details.
         * @param {string} id
         * @param {UpdateWorkspaceDetailsDto} updateWorkspaceDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options) {
            return localVarFp
                .workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update workspace profile picture.
         * @param {string} id
         * @param {UpdateWorkspaceProfilePictureDto} updateWorkspaceProfilePictureDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options) {
            return localVarFp
                .workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkspacesApi - object-oriented interface
 * @export
 * @class WorkspacesApi
 * @extends {BaseAPI}
 */
export class WorkspacesApi extends BaseAPI {
    /**
     *
     * @summary Create a new workspace.
     * @param {CreateWorkspaceDto} createWorkspaceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerCreate(createWorkspaceDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerCreate(createWorkspaceDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all workspaces.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerFindAll(options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerFindAll(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all workspaces with pagination.
     * @param {Array<AbnStatusEnum>} [abnStatus]
     * @param {boolean} [allowPayments] Filter by Royalty Generation payment hold. false &#x3D; payments held.
     * @param {Array<GstStatusEnum>} [gstStatus]
     * @param {Array<MembershipStatusEnum>} [membershipStatus]
     * @param {string} [name]
     * @param {Array<string>} [workspaceIds] Filter workspaces whose id is in the provided list.
     * @param {Array<WorkspaceStatusEnum>} [workspaceStatus]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerFindAllV2(abnStatus, allowPayments, gstStatus, membershipStatus, name, workspaceIds, workspaceStatus, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get workspace by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerFindOne(id, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check whether MSR2 serves the add-title embed for this workspace.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerGetMsr2AddTitleAvailability(id, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerGetMsr2AddTitleAvailability(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a workspace by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerRemove(id, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing workspace.
     * @param {string} id
     * @param {UpdateWorkspaceDto} updateWorkspaceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdate(id, updateWorkspaceDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdate(id, updateWorkspaceDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set allowPayments on a workspace (Royalty Generation payment hold). Staff-only: Service Specialist / Service Supervisor.
     * @param {string} id
     * @param {UpdateAllowPaymentsDto} updateAllowPaymentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdateAllowPayments(id, updateAllowPaymentsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update workspace business details.
     * @param {string} id
     * @param {UpdateWorkspaceBusinessDetailsDto} updateWorkspaceBusinessDetailsDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdateBusinessDetails(id, updateWorkspaceBusinessDetailsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update workspace contact details.
     * @param {string} id
     * @param {UpdateWorkspaceContactDetailsDto} updateWorkspaceContactDetailsDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdateContactDetails(id, updateWorkspaceContactDetailsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update workspace details.
     * @param {string} id
     * @param {UpdateWorkspaceDetailsDto} updateWorkspaceDetailsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdateDetails(id, updateWorkspaceDetailsDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update workspace profile picture.
     * @param {string} id
     * @param {UpdateWorkspaceProfilePictureDto} updateWorkspaceProfilePictureDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspacesApi
     */
    workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options) {
        return WorkspacesApiFp(this.configuration)
            .workspaceControllerUpdateProfilePicture(id, updateWorkspaceProfilePictureDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
